import { Ng2StateDeclaration } from '@uirouter/angular';

import { TrainListComponent } from './components/train-list/train-list.component';

export const trainsState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'pools' is a child of 'app'
    name: 'train-config',
    url: '/project/:projectId/admin/trains',
    component: TrainListComponent,
    params: {
        projectId: {squash: true, value: null}
    }
};

export const TRAINS_STATES = [
    trainsState
];
